const AlertIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.00024 23.9985C4.00024 12.9605 12.9602 3.99854 24.0002 3.99854C35.0602 3.99854 44.0002 12.9605 44.0002 23.9985C44.0002 35.0405 35.0602 43.9985 24.0002 43.9985C12.9602 43.9985 4.00024 35.0405 4.00024 23.9985ZM22.2402 16.4185C22.2402 15.4605 23.0402 14.6585 24.0002 14.6585C24.9602 14.6585 25.7402 15.4605 25.7402 16.4185V25.2585C25.7402 26.2205 24.9602 26.9985 24.0002 26.9985C23.0402 26.9985 22.2402 26.2205 22.2402 25.2585V16.4185ZM24.0202 33.3605C23.0402 33.3605 22.2602 32.5605 22.2602 31.6005C22.2602 30.6405 23.0402 29.8605 24.0002 29.8605C24.9802 29.8605 25.7602 30.6405 25.7602 31.6005C25.7602 32.5605 24.9802 33.3605 24.0202 33.3605Z"
        fill="#57585C"
      />
    </svg>
  );
};

export default AlertIcon;
